import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxWidth: '1200px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxHeight: '90vh',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    gap: '30px',
    padding: '30px',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '25px',
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: theme.palette.primary.main,
  },
  sectionsTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '24px',
    lineHeight: '100%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: '#5BC2D5',
  },
  modalTitleIcon: {
    '&.MuiSvgIcon-root': {
      fontSize: '30px',
    },
  },
  modalTitleAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingLeft: '10px',
  },
  tableContainer: {
    overflow: 'visible',
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    '& .MuiTableCell-head': {
      color: theme.palette.common.white,
      fontWeight: 600,
      fontFamily: 'Montserrat',
    },
  },
  assignButton: {
    textTransform: 'none',
    fontFamily: 'Montserrat',
  },
  fullRow: {
    backgroundColor: theme.palette.action.hover,
  },
}));

export default useStyles;
